module.exports = __webpack_public_path__ + "img/event-1.dfd3f5eb.png";